var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	71061: () => (loadSingletonVersion("default", "@angular/core", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	46607: () => (loadSingletonVersion("default", "@angular/common", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	74464: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	89640: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	46541: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs-_22bb1").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	197: () => (loadSingletonVersion("default", "@angular/core/primitives/di", false, [4,19,2,25], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	89561: () => (loadSingletonVersion("default", "@angular/forms", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	96689: () => (loadSingletonVersion("default", "@angular/common/http", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	41516: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	35269: () => (loadSingletonVersion("default", "@angular/animations/browser", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_browser_mjs-_2a590").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	2097: () => (loadSingletonVersion("default", "@openid/appauth", false, [1,1,3,1], () => (__webpack_require__.e("node_modules_openid_appauth_built_index_js").then(() => (() => (__webpack_require__(/*! @openid/appauth */ 3527))))))),
	36079: () => (loadSingletonVersion("default", "@davita/bridge-utility-library/session-storage", false, [7,19,2,17,,"beta",1], () => (__webpack_require__.e("node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-session-sto-431c970").then(() => (() => (__webpack_require__(/*! @davita/bridge-utility-library/session-storage */ 68098))))))),
	50034: () => (loadSingletonVersion("default", "jwt-decode", false, [1,4,0,0], () => (__webpack_require__.e("node_modules_jwt-decode_build_esm_index_js").then(() => (() => (__webpack_require__(/*! jwt-decode */ 34751))))))),
	84771: () => (loadSingletonVersion("default", "@angular/router", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	69153: () => (loadSingletonVersion("default", "@davita/bridge-utility-library/authorization", false, [7,19,2,17,,"beta",1], () => (__webpack_require__.e("node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-authorizati-fbbfc51").then(() => (() => (__webpack_require__(/*! @davita/bridge-utility-library/authorization */ 50401))))))),
	96169: () => (loadSingletonVersion("default", "@davita/bridge-utility-library/webview", false, [7,19,2,17,,"beta",1], () => (__webpack_require__.e("node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-webview_mjs-_aa871").then(() => (() => (__webpack_require__(/*! @davita/bridge-utility-library/webview */ 75023)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a591": [
		71061
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a81": [
		46607,
		71061
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		71061,
		74464,
		89640
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		71061,
		89640
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1": [
		71061,
		89640,
		74464
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		46541,
		197,
		89640,
		74464
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		46607,
		71061,
		74464,
		89640
	],
	"node_modules_angular_material_fesm2022_autocomplete_mjs-_d4db1": [
		71061,
		89640,
		46607,
		74464,
		89561
	],
	"node_modules_angular_material_fesm2022_bottom-sheet_mjs-_42241": [
		46607,
		71061,
		89640,
		74464
	],
	"node_modules_angular_material_fesm2022_button-toggle_mjs-_b14f1": [
		71061,
		89640,
		74464,
		46607,
		89561
	],
	"node_modules_angular_material_fesm2022_button_mjs-_52ba1": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_card_mjs-_17bd1": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_checkbox_mjs-_fc521": [
		71061,
		89561,
		46607,
		89640,
		74464
	],
	"node_modules_angular_material_fesm2022_chips_mjs-_a4071": [
		71061,
		89640,
		74464,
		46607,
		89561
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb1": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_datepicker_mjs-_f7481": [
		71061,
		89640,
		74464,
		46607,
		89561
	],
	"node_modules_angular_material_fesm2022_dialog_mjs-_b8751": [
		46607,
		71061,
		89640,
		74464
	],
	"node_modules_angular_material_fesm2022_divider_mjs-_593e1": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_expansion_mjs-_0cfc1": [
		71061,
		89640,
		46607,
		74464
	],
	"node_modules_angular_material_fesm2022_form-field_mjs-_1aed1": [
		71061,
		46607,
		89640,
		74464
	],
	"node_modules_angular_material_fesm2022_icon_mjs-_bb191": [
		71061,
		46607,
		89640,
		74464,
		96689,
		41516
	],
	"node_modules_angular_material_fesm2022_input_mjs-_34bc1": [
		71061,
		46607,
		89640,
		74464,
		89561
	],
	"node_modules_angular_material_fesm2022_list_mjs-_3eb01": [
		71061,
		46607,
		89640,
		74464,
		89561
	],
	"node_modules_angular_material_fesm2022_menu_mjs-_fb4a1": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_paginator_mjs-_12ea1": [
		71061,
		89640,
		46607,
		74464,
		89561
	],
	"node_modules_angular_material_fesm2022_progress-bar_mjs-_14ed1": [
		71061,
		46607,
		89640,
		74464
	],
	"node_modules_angular_material_fesm2022_progress-spinner_mjs-_15ea1": [
		71061,
		46607,
		89640,
		74464
	],
	"node_modules_angular_material_fesm2022_radio_mjs-_996c1": [
		71061,
		89640,
		74464,
		46607,
		89561
	],
	"node_modules_angular_material_fesm2022_select_mjs-_b9181": [
		71061,
		89640,
		46607,
		74464,
		89561
	],
	"node_modules_angular_material_fesm2022_slide-toggle_mjs-_025b1": [
		71061,
		89561,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_snack-bar_mjs-_72181": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_sort_mjs-_9a191": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_material_fesm2022_table_mjs-_9ed61": [
		71061,
		89640,
		46607,
		74464
	],
	"node_modules_angular_material_fesm2022_tooltip_mjs-_e18c1": [
		71061,
		89640,
		74464,
		46607
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a0": [
		71061,
		35269,
		46607
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		46607,
		71061,
		96689
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		41516,
		46607,
		71061,
		74464,
		89640
	],
	"node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-authorizati-fbbfc50": [
		2097,
		36079,
		50034,
		71061,
		84771,
		89640,
		96689
	],
	"node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-core_mjs-_67520": [
		71061,
		96689,
		89640,
		74464,
		69153,
		96169,
		36079
	],
	"node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-login_mjs-_2e8a1": [
		71061,
		69153,
		84771
	],
	"node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-session-sto-431c971": [
		71061,
		89640
	],
	"node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-webview_mjs-_aa870": [
		46607,
		69153,
		71061,
		84771,
		89640
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		89640
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		74464,
		89640
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		96689
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		41516,
		46607,
		74464,
		89640
	],
	"node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-authorizati-fbbfc51": [
		2097,
		36079,
		50034,
		84771,
		89640,
		96689
	],
	"node_modules_davita_bridge-utility-library_fesm2022_davita-bridge-utility-library-webview_mjs-_aa871": [
		46607,
		84771
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}